import { render, staticRenderFns } from "./editInspectionPoint.vue?vue&type=template&id=dd060428"
import script from "./editInspectionPoint.vue?vue&type=script&lang=js"
export * from "./editInspectionPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports